const theme = {
  primary: '#A88D6D',
  secondary: '#1F1F1F',
  accent: '#3F51B5',
  error: '#A44C4C',
  warning: '#DAA637',
  info: '#123456',
  success: '#74A86D',
  disabled: '#D1D1D6',
  blue: '#6D8EA8',
};

export default theme;
